import { useState } from 'react';
import S from './NotesStyles';
import NoteItem from './NoteItem/NoteItem';
import AddQuickNote from './AddQuickNote/AddQuickNote';
import useGetNotes from '../../API/hooks/notes/useGetNotes';
import Pagination from '../common/Pagination/Pagination';
import { queryFilters } from '../../utils/queryFilters';

function Notes({
  fleetId, entityName, entityId,
}: any): JSX.Element {
  const [page, setPage] = useState(1);
  const [localFilters, localSetFilters] = useState<Record<string, string[]>>({});
  const { data: notes, isLoading, isFetching } = useGetNotes(fleetId, entityName, entityId, queryFilters(localFilters, page, '&sortField=createdAt&sortOrder=DESC', undefined));

  return (
    <S.Wrapper>
      <div className="header">
        <h3 className="header-title">Notes</h3>
      </div>
      <div className="notes-container">
        <AddQuickNote entityName={entityName} entityId={entityId} fleetId={fleetId} />
        {!isLoading && notes?.results && notes.results.length > 0 && (
          notes.results.map((note: any) => (
            <NoteItem key={note._id} item={note} />
          ))
        )}
        {isLoading && (<p>Loading...</p>)}
        {!isLoading && !notes?.results.length && (<p>No notes created yet</p>)}

      </div>
      <Pagination
        setPage={setPage}
        nextPage={notes?.nextPage}
        prevPage={notes?.prevPage}
        isFetching={isFetching}
      />
    </S.Wrapper>
  );
}

export default Notes;
